import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { ReleaseIcon } from 'assets/icons';
import { selectReleaseRequest } from 'services/store/distribution/selectors';
import BaseIconComponent from '../../BaseIconComponent';

type PropsType = {
  songId: string;
  onClick?: () => void;
};

const ReleaseIconButton = ({ onClick, songId }: PropsType) => {
  const { t } = useTranslation();
  const releaseRequest = useSelector(selectReleaseRequest(songId));
  const isLoading = releaseRequest?.loading;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <BaseIconComponent
        title={t('distribution:tooltip:distribute')}
        icon={<ReleaseIcon />}
        onClick={onClick}
        isLoading={isLoading}
      />
    </Box>
  );
};

export default ReleaseIconButton;
